<template>
    <div v-wechat-title="this.title">
        <van-sticky :offset-top="0">
            <div class="page_top">
                <div class="date_choose">
                    <i class="icon iconfont iconarrow-left-filling" @click="subtractDate"></i>
                    <span class="date_info" @click="chooseCheckDay">{{date || '请选择'}}</span>
                    <i class="icon iconfont iconarrow-right-filling" @click="addDate"></i>
                </div>
                <van-search class="search_div" input-align="center" background="#F8F7FC" @search="reLoad" v-model="keyword" placeholder="患者姓名或手机号" />
            </div>
        </van-sticky>


        <van-calendar v-model="showCalendar" :default-date="defaultDate" :min-date="minDate" :show-confirm="false" @confirm="onConfirmCalendar" />

        <van-dialog
                v-model:show="showBedPopup"
                :show-confirm-button="false"
                :close-on-click-overlay="true"
                class="bed-dialog">
            <template #title>
                <div class="dialog-title">
                    <span>安排床位</span>
                    <span class="close-icon" @click="showBedPopup = false">✕</span>
                </div>
            </template>
            <div class="bed-popup">
                <div class="patient-info-section" v-if="currentPatient">
                    <div class="patient-header">{{currentPatient.name}}</div>
                    <div class="patient-detail">{{currentPatient.sex}} {{currentPatient.age}} {{currentPatient.phone}}</div>
                </div>
                <div class="bed-section">
                    <div class="section-title">床位</div>
                    <div class="bed-list">
                        <div
                                v-for="bed in bedList"
                                :key="bed.room_id"
                                class="bed-item"
                                :class="{
                                    'bed-occupied': bed.use_count > 0  && (bed.user_id != currentPatient.userid || bed.customer_id != currentPatient.customerid),
                                    'bed-available': bed.use_count <= 0 || (bed.use_count > 0 && bed.user_id == currentPatient.userid && bed.customer_id == currentPatient.customerid),
                                    'bed-selected': selectedBed?.room_id == bed.room_id
                                }"
                                @click="selectBed(bed)">
                          <div v-if="bed.room_id != -1" style="text-align: center">
                            <div>{{ bed.room_name }}</div>
                            <div v-if="bed.room_id != -1"> ({{ getBedStatusText(bed) }})</div>
                          </div>
                          <div v-else class="freeRoom">
                            <img src="@/assets/freeRoom.png" alt="">
                            <span>{{ bed.room_name }}</span>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="confirm-section">
                    <div class="confirm-btn" @click="confirmAssignBed">确认安排</div>
                </div>
            </div>
        </van-dialog>

        <van-tabs
                v-model="qrystatus" :offset-top="62"
                @change="changeTab" class="status_div"
                color="#E69F12"
                title-active-color="#E69F12"
                sticky
                swipeable>

            <van-tab title="待分诊" name="5" :badge="waitTriage" >
              <van-pull-refresh v-model="refreshing5" @refresh="onRefresh('5')">
                <div class="treat_main_list" :class="{'bai': count5 <= 0}" >

                    <div
                        class="has_no_data"
                        v-if="!loading5 && finished5 && list5.length === 0">
                      当天无理疗数据
                    </div>

                    <van-list
                            v-else
                            v-model="loading5"
                            :finished="finished5"
                            @load="onLoad"
                            :offset="30"
                            :immediate-check="false"
                            finished-text="加载完成">
                        <template #loading v-if="refreshing5">
                          <div></div>
                        </template>

                        <div class="one"  v-for="item in list5" :key="item.serviceid">
                            <div class="name_appointment">
                                <div class="left" style="width:auto"><label v-if="item.rankicon">{{ item.rankicon }}</label>{{item.name}}</div>
                                <div class="right">
                                  <div class="detail_info" style="width:auto">
                                    <div style="text-align: right;">
                                      <div>{{item.sex}} {{item.age}}</div>
                                      <div>{{item.phone}}</div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div class="sex_age_phone" style="padding-bottom: 0; ">
                            </div>
                            <div class="title_top">
                                <div class="left" style="font-weight:bold;font-size:0.4rem" v-if="item.projectname">
                                    <span v-for="(project, index) in item.projectname.split(',')" :key="index">
                                        <span v-if="index > 0"><br></span>
                                        {{ project }}
                                    </span>
                                </div>
                                <div v-else class="left" style="font-weight:bold;font-size:0.4rem">
                                      理疗预约
                                </div>
                                <div class="right" style="color:#999">
                                    <div><span style="margin-right:10px" >{{item.appointmentnum}}</span><span v-if="item.projectname">转理疗</span></div>
                                    <div>{{item.appointmenttime}}</div>
                                </div>
                            </div>
                            <div style="display: flex;justify-content: flex-end;">
                                <div @click="goAssignTreat(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">分诊</div>

                                <div @click="openBedPopup(item)" v-if="item.projectname"
                                    style="background-color: #CF8C57;text-align: center;color: #fff;border-radius: 10px;font-size:0.36rem;padding:8px 15px">
                                    {{ item.roomid ? '床位：'+item.roomname : '安排床位' }}
                                </div>
                            </div>
                        </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>

            <van-tab title="待执行" name="2" :badge="wait" >
              <van-pull-refresh v-model="refreshing2" @refresh="onRefresh('2')">
                <div class="treat_main_list" :class="{'bai': count2 <= 0}" >
                  <div
                      class="has_no_data"
                      v-if="!loading2 && finished2 && list2.length === 0">
                    当天无理疗数据
                  </div>

                    <van-list
                            v-else
                            v-model="loading2"
                            :finished="finished2"
                            @load="onLoad"
                            :offset="30"
                            :immediate-check="false"
                            finished-text="加载完成">
                        <template #loading v-if="refreshing2">
                          <div></div>
                        </template>
                        <div class="one"  v-for="item in list2" :key="item.serviceid">
                            <div class="name_appointment">
                                <div class="left" style="width:auto"><label v-if="item.rankicon">{{ item.rankicon }}</label>{{item.name}}</div>
                                <span @click="openBedPopup(item)"
                                      style="text-align: center;color: #CF8C57;font-size:0.36rem;">
                                  {{ item.roomid ? '床位：'+item.roomname : '安排床位' }}
                                </span>
                                <div class="right">
                                  <div class="detail_info" style="width:auto" @click="detailCtrl(item.serviceid)">
                                    <div style="text-align: right;">
                                      <div>{{item.sex}} {{item.age}}</div>
                                      <div>{{item.phone}}</div>
                                    </div>
                                    <i class="icon iconfont iconsanjiaoyou"></i>
                                  </div>
                                </div>
                            </div>
                            <div class="sex_age_phone" style="padding-bottom: 0; ">
                            </div>
                            <div class="title_top">
                                <div class="left" style="font-weight:bold;font-size:0.4rem">{{item.projectname}}</div>
                                <div class="right" style="color:#999">
                                  <div><span style="margin-right:10px">{{item.appointmentnum}}</span><span>{{item.apptype}}</span></div>
                                  <div>{{item.appointmenttime}}</div>
                                </div>
                            </div>
                            <div
                                class="title_top"
                                v-for="(doctor, index) in item.doctorlist"
                                :key="index"
                            >
                              <div class="left doctor-left">
                                <span v-if="doctor.ismain == 1" class="main-tag">主</span>
                                {{ doctor.dispname }}
                                <span class="point-text" v-if="doctor.pointlist && doctor.pointlist.length">
                                  ({{ doctor.pointlist.join(',') }})
                                </span>
                              </div>
                              <div class="right doctor-right" :class="getStatusClass(doctor)" @click="handleDoctorClick(doctor, item)">
                                <div class="time">
                                  {{ formatTime(doctor, item) }}
                                </div>
                                <div class="status-text">
                                  {{ formatStatus(doctor) }}
                                </div>
                              </div>
                            </div>

                            <div style="display: flex;justify-content: flex-end;">
                              <div @click="goAssignTreat(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">加项目</div>

                              <div v-if="!item.signaturetime" @click="searchList(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">去签名</div>

                              <van-button type="primary" color="#CF8C57" class="r-btn" size="small" @click="openAcupointDialog(item)">配穴分工</van-button>
                            </div>
                        </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>

            <van-tab  title="执行中" name="3" :badge="execute">
              <van-pull-refresh v-model="refreshing3" @refresh="onRefresh('3')">
                <div class="treat_main_list" :class="{'bai': count3 <= 0}">
                    <div
                        class="has_no_data"
                        v-if="!loading3 && finished3 && list3.length === 0">
                      当天无理疗数据
                    </div>

                    <van-list
                        v-else
                        v-model="loading3"
                        :finished="finished3"
                        @load="onLoad"
                        :offset="30"
                        :immediate-check="false"
                        finished-text="加载完成">
                      <template #loading v-if="refreshing3">
                        <div></div>
                      </template>
                      <div class="one"  v-for="item in list3" :key="item.serviceid">
                        <div class="name_appointment">
                          <div class="left" style="width:auto"><label v-if="item.rankicon">{{ item.rankicon }}</label>{{item.name}}</div>
                          <span @click="openBedPopup(item)"
                                style="text-align: center;color: #CF8C57;font-size:0.36rem;">
                                    {{ item.roomid ? '床位：'+item.roomname : '安排床位' }}
                                  </span>
                          <div class="right">
                            <div class="detail_info" style="width:auto" @click="detailCtrl(item.serviceid)">
                              <div style="text-align: right;">
                                <div>{{item.sex}} {{item.age}}</div>
                                <div>{{item.phone}}</div>
                              </div>
                              <i class="icon iconfont iconsanjiaoyou"></i>
                            </div>
                          </div>
                        </div>
                        <div class="sex_age_phone" style="padding-bottom: 0; ">
                        </div>
                        <div class="title_top">
                          <div class="left" style="font-weight:bold;font-size:0.4rem">{{item.projectname}}</div>
                          <div class="right" style="color:#999">
                            <div><span style="margin-right:10px">{{item.appointmentnum}}</span><span>{{item.apptype}}</span></div>
                            <div>{{item.appointmenttime}}</div>
                          </div>
                        </div>
                        <div
                            class="title_top"
                            v-for="(doctor, index) in item.doctorlist"
                            :key="index"
                        >
                          <div class="left doctor-left">
                            <span v-if="doctor.ismain == 1" class="main-tag">主</span>
                            {{ doctor.dispname }}
                            <span class="point-text" v-if="doctor.pointlist && doctor.pointlist.length">
                                    ({{ doctor.pointlist.join(',') }})
                                  </span>
                          </div>
                          <div class="right doctor-right" :class="getStatusClass(doctor)" @click="handleDoctorClick(doctor, item)">
                            <div class="time">
                              {{ formatTime(doctor, item) }}
                            </div>
                            <div class="status-text">
                              {{ formatStatus(doctor) }}
                            </div>
                          </div>
                        </div>

                        <div style="display: flex;justify-content: flex-end;">
                          <div @click="goAssignTreat(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">加项目</div>

                          <div v-if="!item.signaturetime" @click="searchList(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">去签名</div>

                          <van-button type="primary" color="#CF8C57" class="r-btn" size="small" @click="openAcupointDialog(item)">配穴分工</van-button>
                        </div>
                      </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>

            <van-tab  title="已完成" name="4" :badge="finish" >
              <van-pull-refresh v-model="refreshing4" @refresh="onRefresh('4')">
                <div class="treat_main_list" :class="{'bai': count4 <= 0}">
                    <div
                        class="has_no_data"
                        v-if="!loading4 && finished4 && list4.length === 0">
                      当天无理疗数据
                    </div>
                    <van-list
                        v-else
                        v-model="loading4"
                        :finished="finished4"
                        @load="onLoad"
                        :offset="30"
                        :immediate-check="false"
                        finished-text="加载完成">
                      <template #loading v-if="refreshing4">
                        <div></div>
                      </template>
                      <div class="one"  v-for="item in list4" :key="item.serviceid">
                        <div class="name_appointment">
                          <div class="left" style="width:auto"><label v-if="item.rankicon">{{ item.rankicon }}</label>{{item.name}}</div>
                          <span style="text-align: center;color: #CF8C57;font-size:0.36rem;">
                                      {{ item.roomid ? '床位：'+item.roomname : '安排床位' }}
                                    </span>
                          <div class="right">
                            <div class="detail_info" style="width:auto" @click="detailCtrl(item.serviceid)">
                              <div style="text-align: right;">
                                <div>{{item.sex}} {{item.age}}</div>
                                <div>{{item.phone}}</div>
                              </div>
                              <i class="icon iconfont iconsanjiaoyou"></i>
                            </div>
                          </div>
                        </div>
                        <div class="sex_age_phone" style="padding-bottom: 0; ">
                        </div>
                        <div class="title_top">
                          <div class="left" style="font-weight:bold;font-size:0.4rem">{{item.projectname}}</div>
                          <div class="right" style="color:#999">
                            <div><span style="margin-right:10px">{{item.appointmentnum}}</span><span>{{item.apptype}}</span></div>
                            <div>{{item.appointmenttime}}</div>
                          </div>
                        </div>
                        <div
                            class="title_top"
                            v-for="(doctor, index) in item.doctorlist"
                            :key="index"
                        >
                          <div class="left doctor-left">
                            <span v-if="doctor.ismain == 1" class="main-tag">主</span>
                            {{ doctor.dispname }}
                            <span class="point-text" v-if="doctor.pointlist && doctor.pointlist.length">
                                      ({{ doctor.pointlist.join(',') }})
                                    </span>
                          </div>
                          <div class="right doctor-right" :class="getStatusClass(doctor)" @click="handleDoctorClick(doctor, item)">
                            <div class="time">
                              {{ formatTime(doctor, item) }}
                            </div>
                            <div class="status-text">
                              {{ formatStatus(doctor) }}
                            </div>
                          </div>
                        </div>

                        <div style="display: flex;justify-content: flex-end;">
                          <div @click="goAssignTreat(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">加项目</div>

                          <van-button type="primary" color="#CF8C57" class="r-btn" size="small" @click="openAcupointDialog(item)">配穴分工</van-button>
                        </div>
                      </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>
        </van-tabs>

        <div class="btnimg" @click="$router.push({path:'/triage'})">
            <img src="@/assets/btn.png" alt="">
        </div>

        <acupoint-allocation
            :visible.sync="showAcupointDialog"
            :qryType="2"
            :uname="uname"
            :usex="usex"
            :uage="uage"
            :uphone="uphone"
            :userId="Number(currentUserId)"
            :customerId="Number(currentCustomerId)"
            :tCode="currenttCode"
            :serviceId="currentServiceId"
            :currentallpoints="currentAllPoints"
            :currentAcupointData="currentAcupointData"
            @save="handleAcupointSave"
        />
    </div>
</template>

<script>
import {wxtreatstatistics, wxtreatqry, wxqryfreeroom, wxsaveroom, wxoprtreat, waitsignaturelist} from '@/api/medical'
    import { mapGetters } from 'vuex'
    // import Vue from 'vue';
    import { Toast,Dialog } from 'vant';
    import Vue from 'vue';
    import { Calendar } from 'vant';
    import AcupointAllocation from "@/view/acupointAllocation/index.vue";
    import { getServerNow } from '@/utils/time'

    Vue.use(Calendar);

    export default {
      components: {AcupointAllocation},
        computed: {
            ...mapGetters([
                'username','clinicid','isrefresh','isclose','clinicname'
            ]),
        },
        data() {
            return {
                qrystatus: '1',
                oldQrystatus: '1',
                list5: [],
                loading5: false,
                finished5: false,
                count5: 0,
                page5: 1,
                isload5: false,
                refreshing5: false,

                list2: [],
                // 无限加载
                loading2: false,
                finished2: false,
                count2: 0,
                page2: 1,
                isload2: false,
                refreshing2: false,

                list3: [],
                // 无限加载
                loading3: false,
                finished3: false,
                count3: 0,
                page3: 1,
                isload3: false,
                refreshing3: false,

                list4: [],
                // 无限加载
                loading4: false,
                finished4: false,
                count4: 0,
                page4: 1,
                isload4: false,
                refreshing4: false,
                keyword: '',
                waitTriage: 0,
                wait: 0,
                execute: 0,
                finish:0,
                minDate: new Date(2020, 0, 1),
                defaultDate: new Date(),
                date:'',
                showCalendar:false,
                title:'理疗工作台',
                loading: false,
                showBedPopup: false,
                bedList: [],
                selectedBed: null,
                currentPatient: null,

                showAcupointDialog:false,
                uname:null,
                usex:null,
                uphone:null,
                uage:null,
                currentAllPoints:null,
                currentAcupointData:[],
                currentItemRef: null,
                currentServiceId: null,
                currentUserId: null,
                currentCustomerId: null,
                currenttCode: null,

                timer: null,
                signaturelist:[]
            }
        },
        mounted () {
            this.$store.dispatch('changeIsClose', '1')
            this.$store.dispatch('changeNav', '0')
            this.$store.dispatch('hideOrShowNav', false)
            this.getCurDate()

            const lastTab = sessionStorage.getItem('TREAT_PAGE_TAB')
            if (lastTab) {
              this.qrystatus = lastTab
              this.oldQrystatus = lastTab
              sessionStorage.removeItem('TREAT_PAGE_TAB')
            }


            this.startTimer()
            this.setListLoading(this.qrystatus, true)
            this.onLoad()
        },
        beforeDestroy() {
          clearInterval(this.timer)
        },
        activated() {
            this.$store.dispatch('changeNav', '0')
            this.$store.dispatch('hideOrShowNav', false)
            console.log(this.isrefresh, '----isrefresh')
            if(this.isrefresh == '1' && !this.loading) {
                this.$store.dispatch('changeIsRefresh', '0')
                this.reLoad();
            }
        },
        beforeRouteLeave(to, from, next) {
            console.log(to,from,'treat-----')
            if(to.path == '/assignTreat'){
                from.meta.keepAlive = false

            }else if(to.path == '/triage'){
                to.meta.keepAlive = false
            }
            next()
        },
        methods: {
            goBack() {
                window.WeixinJSBridge.call('closeWindow')
            },
            getCurDate() {
                const nowDate = new Date();
                this.formatDate(nowDate)
            },
            addDate() {
                var d = new Date(this.date);
                d.setDate(d.getDate() + 1);
                this.formatDate(d)
                this.reLoad()
            },
            subtractDate() {
                var d = new Date(this.date);
                d.setDate(d.getDate() - 1);
                this.formatDate(d)
                this.reLoad()
            },
            formatDate(d) {
                const curDate = {
                    year: d.getFullYear(),
                    month: d.getMonth() + 1,
                    date: d.getDate(),
                }
                const newmonth = curDate.month>=10?curDate.month:'0'+curDate.month
                const day = curDate.date>=10?curDate.date:'0'+curDate.date
                this.date = curDate.year + '-' + newmonth + '-' + day
                this.defaultDate = new Date(this.date);
            },
            chooseCheckDay(){
                this.showCalendar = true
            },
            onConfirmCalendar(date){
                this.showCalendar = false
                this.formatDate(date);

                this.reLoad()
            },

            changeTab(name){
              if (this.loading) {
                Toast('数据加载中，请稍后再切换')

                this.$nextTick(() => {
                  this.qrystatus = this.oldQrystatus
                })

                return
              }

              this.oldQrystatus = name
              this.qrystatus = name

              this.resetCurrentTab(name)

              this.setListLoading(name, true)
              this.onLoad()
            },
            setListLoading(status, value) {
              if (status === '5') this.loading5 = value
              if (status === '2') this.loading2 = value
              if (status === '3') this.loading3 = value
              if (status === '4') this.loading4 = value
            },
            reLoad(){
                this.finished5 = false
                this.loading5 = false
                this.count5 = 0
                this.page5 = 1
                this.list5 = []
                this.isload5 = false

                this.finished2 = false
                this.loading2 = false
                this.count2 = 0
                this.page2 = 1
                this.list2 = []
                this.isload2 = false

                this.finished3 = false
                this.loading3 = false
                this.count3 = 0
                this.page3 = 1
                this.list3 = []
                this.isload3 = false

                this.finished4 = false
                this.loading4 = false
                this.count4 = 0
                this.page4 = 1
                this.list4 = []
                this.isload4 = false
                this.onLoad()
            },
            onLoad(){
                console.log(this.clinicid, '*****this.clinicid')
                if(this.clinicid == null || this.clinicid == '' || this.clinicid == undefined
                    || this.username == null || this.username == '' || this.username == undefined) {
                    Toast.loading({
                        duration: 0, // 持续展示 toast
                        forbidClick: true,
                        message: '未登录或未选择诊所，页面关闭',
                    });
                    let second = 1;
                    const timer = setInterval(() => {
                        second--;
                        if (!second) {
                            clearInterval(timer);
                            // 手动清除 Toast
                            Toast.clear();
                            this.goBack()
                        }
                    }, 1000);
                    return;

                }
                if(this.qrystatus === '5' && this.finished5) {
                    return
                }
                if(this.qrystatus === '2' && this.finished2) {
                    return
                }
                if(this.qrystatus === '3' && this.finished3) {
                    return
                }
                if(this.qrystatus === '4' && this.finished4) {
                    return
                }
                if (this.loading) return

                this.loading = true

                let sdata = {
                    username: this.username,
                    qrydate: this.date,
                    keyword: this.keyword,
                    clinicid: this.clinicid
                }
                wxtreatstatistics(sdata).then(response => {
                    if(response.response_body){
                        let old_waitTriage = this.waitTriage
                        let old_wait = this.wait
                        let old_execute = this.execute
                        let old_finish = this.finish
                        this.waitTriage = parseInt(response.response_body.waitTriage || 0)
                        if(this.isload5 && this.waitTriage != old_waitTriage) {
                            this.finished5 = false
                            this.loading5 = false
                            this.count5 = 0
                            this.page5 = 1
                            this.list5 = []
                            this.isload5 = false
                        }
                        this.wait = parseInt(response.response_body.wait)
                        if(this.isload2 && this.wait != old_wait) {
                            this.finished2 = false
                            this.loading2 = false
                            this.count2 = 0
                            this.page2 = 1
                            this.list2 = []
                            this.isload2 = false
                        }
                        this.execute = parseInt(response.response_body.execute)
                        if(this.isload3 && this.execute != old_execute) {
                            this.finished3 = false
                            this.loading3 = false
                            this.count3 = 0
                            this.page3 = 1
                            this.list3 = []
                            this.isload3 = false
                        }
                        this.finish = parseInt(response.response_body.finish)
                        if(this.isload4 && this.finish != old_finish) {
                            this.finished4 = false
                            this.loading4 = false
                            this.count4 = 0
                            this.page4 = 1
                            this.list4 = []
                            this.isload4 = false
                        }
                    }
                    let qryPage = 1;
                    if(this.qrystatus === '5') {
                        qryPage = this.page5
                    }
                    if(this.qrystatus === '2') {
                        qryPage = this.page2
                    }
                    if(this.qrystatus === '3') {
                        qryPage = this.page3
                    }
                    if(this.qrystatus === '4') {
                        qryPage = this.page4
                    }
                    let data = {
                        username: this.username,
                        qrydate: this.date,
                        keyword: this.keyword,
                        page: qryPage + '',
                        qrystatus: this.qrystatus,
                        clinicid: this.clinicid
                    }
                    wxtreatqry(data).then(response => {
                        if(Toast){
                            Toast.clear()
                        }
                        if(this.qrystatus === '5') {
                            this.isload5 = true
                        }
                        if(this.qrystatus === '2') {
                            this.isload2 = true
                        }
                        if(this.qrystatus === '3') {
                            this.isload3 = true
                        }
                        if(this.qrystatus === '4') {
                            this.isload4 = true
                        }
                        if(response.response_body && response.response_body.list){
                            if(this.qrystatus === '5') {
                                this.count5 = parseInt(response.response_body.num)
                                this.list5 = this.list5.concat(response.response_body.list)
                                this.finished5 = (this.page5 >= response.response_body.pages);
                                this.page5 = parseInt(this.page5)+1
                            }
                            if(this.qrystatus === '2') {
                                this.count2 = parseInt(response.response_body.num)
                                this.list2 = this.list2.concat(response.response_body.list)
                                this.finished2 = (this.page2 >= response.response_body.pages);
                                this.page2 = parseInt(this.page2)+1
                            }
                            if(this.qrystatus === '3') {
                                this.count3 = parseInt(response.response_body.num)
                                this.list3 = this.list3.concat(response.response_body.list)
                                this.finished3 = (this.page3 >= response.response_body.pages);
                                this.page3 = parseInt(this.page3)+1
                            }
                            if(this.qrystatus === '4') {
                                this.count4 = parseInt(response.response_body.num)
                                this.list4 = this.list4.concat(response.response_body.list)
                                this.finished4 = (this.page4 >= response.response_body.pages);
                                this.page4 = parseInt(this.page4)+1
                            }

                        }else {

                          // 没数据时必须结束加载，否则一直循环请求
                          if(this.qrystatus === '5') {
                            this.finished5 = true
                          }

                          if(this.qrystatus === '2') {
                            this.finished2 = true
                          }

                          if(this.qrystatus === '3') {
                            this.finished3 = true
                          }

                          if(this.qrystatus === '4') {
                            this.finished4 = true
                          }
                        }

                      this.setListLoading(this.qrystatus, false)
                      this.loading = false
                      this.setRefreshing(this.qrystatus, false)
                    })
                })


            },

            // 理疗详情
            detailCtrl(serviceid){
                this.$store.dispatch('changeIsRefresh', '0')
                this.$router.push({
                    path: '/treatDetail',
                    query: {
                        serviceid: serviceid
                    }
                })
            },
            openBedPopup(item) {
                this.currentPatient = item
                this.selectedBed = null
                this.bedList = []
                this.showBedPopup = true
                wxqryfreeroom({ clinicid: this.clinicid }).then(response => {
                    if (response.response_body && response.response_body.list) {
                        this.bedList = response.response_body.list
                        // 增加“无需床位”选项
                        this.bedList.push({
                          room_id: -1,
                          room_name: '无需床位',
                          use_count: 0
                        })

                        let defaultBed = null
                        if (item.roomid) {
                          defaultBed = this.bedList.find(
                              bed => bed.room_id == item.roomid
                          )
                        }

                        // 如果没有当前床位，则默认选中第一个空闲床位
                        if (!defaultBed) {
                          defaultBed = this.bedList.find(
                              bed => bed.use_count <= 0
                          )
                        }

                        // 设置默认选中
                        if (defaultBed) {
                          this.selectedBed = defaultBed
                        }
                    }
                })
            },
            selectBed(bed) {
                // 无需床位允许选中
                if (bed.room_id != -1 && bed.use_count > 0 && (bed.user_id != this.currentPatient.userid || bed.customer_id != this.currentPatient.customerid)) {
                  return
                }

                this.selectedBed = bed
            },
            getBedStatusText(bed) {
                // 无需床位
                if (bed.room_id == -1) {
                  return ''
                }
                if (bed.use_count > 0) {
                    if (this.currentPatient &&
                        this.currentPatient.userid ==  bed.user_id &&
                        this.currentPatient.customerid == bed.customer_id) {
                        return '本人';
                    }
                    return '有人';
                }
                return '空闲';
            },
            confirmAssignBed() {
                if (!this.selectedBed) {
                    Toast('请先选择床位')
                    return
                }
                wxsaveroom({
                    roomId: this.selectedBed.room_id,
                    userId: this.currentPatient.userid,
                    customerId: this.currentPatient.customerid,
                    date: this.date,
                    username: this.username,
                    serviceid: this.currentPatient.allserviceid,
                    clinicid: this.clinicid
                }).then((response) => {
                      if (response.response_body.flag) {
                        Toast.success('安排床位成功')
                        this.showBedPopup = false

                        // 跳转分诊
                        if (this.qrystatus == '5' && response.response_body.isjumppage){
                          this.goAssignTreat(this.currentPatient)
                          return;
                        }
                        this.reLoad()
                      }else{
                        Toast.fail(response.response_body.msg)
                      }
                })
            },

            openAcupointDialog(item) {
              this.currentItemRef = item
              this.uname = item.name
              this.uphone = item.phone
              this.usex = item.sex
              this.uage = item.age
              this.currentServiceId = item.serviceid
              this.currentAllPoints = item.allpoints
              this.currentAcupointData = item.doctorlist
              this.currentUserId = item.userid
              this.currentCustomerId = item.customerid
              this.currenttCode = item.projectcode
              this.showAcupointDialog = true
            },

            // 状态文字
            formatStatus(doctor) {
              if (doctor.status == 0) return '开始治疗'
              if (doctor.status == 1) return '完成治疗'
              if (doctor.status == 2) return '已完成'
              return ''
            },

            // 时间显示
            formatTime(doctor, item) {
              if (doctor.status == 0) {
                return '--:--'
              }

              let seconds = 0

              // 已完成
              if (doctor.status == 2) {
                seconds = this.getSeconds(doctor.endtime) - this.getSeconds(doctor.starttime)
              }

              // 执行中（动态）
              if (doctor.status == 1) {
                seconds = Math.floor(getServerNow() / 1000) - this.getSeconds(doctor.starttime)
              }

              if (seconds < 0) seconds = 0

              const m = Math.floor(seconds / 60)
              const s = seconds % 60

              return `${this.pad(m)}:${this.pad(s)}`
            },

            // 时间转秒（兼容字符串）
            getSeconds(time) {
              if (!time) return 0

              const safeTime = time.replace(/-/g, '/')
              const timestamp = new Date(safeTime).getTime()
              if (isNaN(timestamp)) return 0

              return Math.floor(timestamp / 1000)
            },

            pad(num) {
              return num < 10 ? '0' + num : num
            },

            startTimer() {
              this.timer = setInterval(() => {
                // 触发视图更新（关键）
                this.$forceUpdate()
              }, 1000)
            },

            getStatusClass(doctor) {
              if (doctor.status == 2) return 'status-finished'
              return 'status-active'
            },

            handleDoctorClick(doctor, item) {
              // 已完成不允许再点
              if (doctor.status == 2) return

              let oprtype = null
              let text = ''

              if (doctor.status == 0) {
                oprtype = 1
                text = '确认开始治疗？'
              }

              if (doctor.status == 1) {
                oprtype = 2
                text = '确认结束治疗？'
              }

              // 二次确认
              Dialog.confirm({
                title: '提示',
                message: text,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
              })
                  .then(() => {
                    // 点击确认才执行接口
                    wxoprtreat({
                      serviceId: item.serviceid,
                      treatId: doctor.treatid,
                      oprType: oprtype,
                      doctor: this.username
                    }).then((response) => {
                      if (response.response_body.flag) {
                        Toast.success('操作成功')

                        // 更新状态
                        doctor.status = oprtype

                        // 使用接口返回时间
                        if (oprtype == 1) {
                          doctor.starttime = response.response_body.startTime

                          if (response.response_body.isStart === true) {
                            this.qrystatus = '3'
                            this.oldQrystatus = '3'

                            this.reLoad()
                            return
                          }
                        }

                        if (oprtype == 2) {
                          doctor.endtime = response.response_body.endTime

                          if (response.response_body.isEnd === true) {
                            this.qrystatus = '4'
                            this.oldQrystatus = '4'

                            Toast({
                              message: '加载中...',
                              type: 'loading',
                              duration: 0
                            })

                            this.reLoad()
                            return
                          }
                        }
                      }else{
                        if (!response.response_body.issign){
                          Dialog.confirm({
                            title: '提示',
                            message: response.response_body.msg,
                            confirmButtonText: '去签名',
                            cancelButtonText: '取消'
                          })
                          .then(() => {
                            this.searchList(item)
                          })
                          .catch(() => {
                            // 点击取消，不做任何事
                          })
                        }else{
                          Toast.fail(response.response_body.msg)
                        }
                      }
                    })
                  })
                  .catch(() => {
                    // 点击取消，不做任何事
                  })
            },

            handleAcupointSave(newList) {
              if (!this.currentItemRef) return

              // 关键：直接覆盖 doctors
              this.$set(this.currentItemRef, 'doctorlist', newList)

              //刷新页面
              this.reLoad()
            },

            //签名
            // 待签名服务查询  waitsignaturelist
            // 查询待签名列表
            searchList(item){
              console.log('item',item)
              let value = {
                username: this.username,
                serviceid: item.serviceid,
              };
              waitsignaturelist(value).then(res =>{

                this.signaturelist = res.response_body.list

                this.changeRouter(item);
              })
            },
            changeRouter(item){
              var arr = [...this.signaturelist]

              let datas = arr.filter(vo => vo.projectcode != item.projectcode).map(vo => vo.projectname )

              if(datas.length > 0){

                Dialog.confirm({
                  title: '提示',
                  message: `患者当天还存在其他理疗项目（${datas.join('、')}）未签名，是否同步签名`,
                  confirmButtonText:'全部签名',
                  cancelButtonText:'仅签名当前项目',
                })
                    .then(() => {
                      // on confirm
                      this.$router.push({
                        path:'/signature',
                        query:{
                          serviceid:item.serviceid ,
                          isAll:'true',
                        }
                      })
                    })
                    .catch(() => {
                      // on cancel
                      this.$router.push({
                        path:'/signature',
                        query:{
                          serviceid:item.serviceid ,
                          isAll:'false',
                        }
                      })
                    });
              }else{
                this.$router.push({
                  path:'/signature',
                  query:{
                    serviceid:item.serviceid ,
                    isAll:'false',
                  }
                })
              }
            },
            onRefresh(status) {
              if (this.loading) {
                this.setRefreshing(status, false)
                Toast('数据加载中，请稍后刷新')
                return
              }

              this.qrystatus = status
              this.oldQrystatus = status

              this.resetCurrentTab(status)

              this.onLoad()
            },
            resetCurrentTab(status) {
              if (status === '5') {
                this.finished5 = false
                this.loading5 = false
                this.count5 = 0
                this.page5 = 1
                this.list5 = []
                this.isload5 = false
              }

              if (status === '2') {
                this.finished2 = false
                this.loading2 = false
                this.count2 = 0
                this.page2 = 1
                this.list2 = []
                this.isload2 = false
              }

              if (status === '3') {
                this.finished3 = false
                this.loading3 = false
                this.count3 = 0
                this.page3 = 1
                this.list3 = []
                this.isload3 = false
              }

              if (status === '4') {
                this.finished4 = false
                this.loading4 = false
                this.count4 = 0
                this.page4 = 1
                this.list4 = []
                this.isload4 = false
              }
            },
            setRefreshing(status, value) {
              if (status === '5') this.refreshing5 = value
              if (status === '2') this.refreshing2 = value
              if (status === '3') this.refreshing3 = value
              if (status === '4') this.refreshing4 = value
            },
            goAssignTreat(item){
              sessionStorage.setItem('TREAT_PAGE_TAB', this.qrystatus)
              this.$store.dispatch('changeIsRefresh', '1')

              this.$router.push({
                path: '/assignTreat',
                query: {
                  userid: item.userid,
                  customerid: item.customerid,
                  name: item.name || '',
                  sex: item.sex || '',
                  age: item.age || '',
                  phone: item.phone || '',
                  appointmentid: item.appointmentid || '',
                  roomid: item.roomid || '',
                  roomname: item.roomname || ''
                }
              })
            }
        },
    }
</script>

<style lang="scss" scoped>
    .van-info{
        top: 2px;
        right: -8px;
    }
    .van-cell{
        background-color: #F8F7FC;
        border-radius: 0.50667rem;
    }
    .bai {
        background-color: #ffffff;
    }
    .btnimg{
        width: 50px;
        height: 50px;
        position: fixed;
        right: 10px;
        bottom: 200px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .treat_main_list .one{
        background: linear-gradient( 180deg, rgba(207,140,87,0.2) 0%, rgba(255,249,244,0) 20%);
        padding: 16px;
        border-radius: 12px;
        margin: 12px;
    }
    .card-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 12px;
        border-bottom: 1px solid #f0f0f0;
    }
    .patient-info {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
    .patient-name {
        font-size: 16px;
        font-weight: 500;
        color: #333;
    }
    .patient-detail {
        font-size: 14px;
        color: #666;
    }
    .card-middle {
        padding: 12px 0;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }
    .project-name {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        flex: 1;
        margin-right: 12px;
    }
    .time-location {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 4px;
        font-size: 14px;
        color: #666;
    }
    .card-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 12px;
    }
    .triage-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #CF8C57;
        font-size: 14px;
        cursor: pointer;
    }
    .bed-info {
        background: #CF8C57;
        color: #fff;
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 14px;
    }
    .bed-dialog {
        width: 90%;
        max-width: 400px;
        border-radius: 12px;
    }
    .bed-dialog :deep(.van-dialog__header) {
        padding: 20px 20px 10px;
    }
    .dialog-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .dialog-title span:first-child {
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    .close-icon {
        font-size: 20px;
        color: #999;
        cursor: pointer;
        line-height: 1;
    }
    .bed-dialog :deep(.van-dialog__content) {
        max-height: 70vh;
        overflow-y: auto;
    }
    .bed-popup {
        padding: 10px 0 0;
    }
    .patient-info-section {
        background: #CF8C57;
        border-radius: 12px;
        padding: 20px;
        margin: 0 20px 24px;
    }
    .patient-header {
        font-size: 22px;
        font-weight: 600;
        color: #fff;
        margin-bottom: 10px;
    }
    .patient-detail {
        font-size: 16px;
        color: #fff;
    }
    .bed-section {
        padding: 0 20px;
    }
    .section-title {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin-bottom: 16px;
    }
    .bed-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
    }
    .bed-item {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        font-size: 16px;
        cursor: pointer;
        padding: 8px;
        flex-direction: column;
    }
    .bed-occupied {
        background: #ddd;
        color: #999;
        cursor: not-allowed;
    }
    .bed-available {
        background: #fff;
        border: 1px solid #CF8C57;
        color: #CF8C57;
    }
    .bed-selected {
        background: #CF8C57 !important;
        color: #fff !important;
        border: 1px solid #CF8C57;
    }
    .confirm-section {
        padding: 20px;
    }
    .confirm-btn {
        width: 100%;
        height: 50px;
        background: #CF8C57;
        color: #fff;
        border-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: 600;
    }

    .point-text {
      color: #999;
      margin-left: 4px;
    }


    .doctor-left {
      width: 75% !important;
      word-break: break-all;
      white-space: normal !important;
      line-height: 1.4;
    }

    .doctor-right {
      width: 25% !important;
      text-align: center !important;
      border-radius: 8px;
      padding: 5px;
    }

    .main-tag {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      background: #CF8C57; /* 土黄 */
      color: #fff;
      border-radius: 50%;
      font-size: 12px;
      margin-right: 6px;
      flex-shrink: 0;
    }

    /* 已完成：灰底灰字 */
    .status-finished {
      background: #f2f2f2;
      color: #999;
    }

    /* 未开始 + 执行中：土黄底白字 */
    .status-active {
      background: #CF8C57;
      color: #fff;
    }

    /* 时间 */
    .time {
      font-size: 14px;
    }

    /* 状态文字 */
    .status-text {
      font-size: 12px;
      margin-top: 2px;
    }

    .freeRoom{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .freeRoom img{
      width: 30px;
    }

    .page-loading {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 9999;
      background: rgba(255, 255, 255, 0.75);
      display: flex;
      align-items: center;
      justify-content: center;
    }
</style>
